import './preprocessHero';
import { useAsset } from '@artica/assets';
import HeroPaths from './HeroPaths';
import heroCardUnresolvedAnim from './heroCardUnresolved.animation.json';
import heroCardResolvedAnim from './heroCardResolved.animation.json';
import heroCardFailAnim from './heroCardFail.animation.json';
import HeroCard from './HeroCard';
import heroCardsUnresolved from './heroCardsUnresolved.json';
import heroCardsResolved from './heroCardsResolved.json';

export default function Hero() {
  const { nodes } = useAsset('hero_cards');
  const paths = useAsset('hero_path');
  return (
    <group name="Hero">
      <HeroPaths
        paths={ paths }
      />
      <group name="Hero_Cards">
        <group name="Hero_Cards_Unresolved" rotation={ [0, 0.59, 0] }>
          { heroCardsUnresolved.map(({ position, rotation, scale }, idx) => (
            <HeroCard
              key={ idx }
              geometry={ nodes.Card_Hero_Unresolved_111.geometry }
              position={ position }
              rotation={ rotation }
              scale={ scale }
              animation={ heroCardUnresolvedAnim }
            />
          )) }
        </group>
        <group name="Hero_Cards_Resolved" rotation={ [0, 0.59, 0] }>
          { heroCardsResolved.map(({ position, rotation, scale }, idx) => (
            <HeroCard
              key={ idx }
              geometry={nodes.Card_Hero_Resolved_273.geometry}
              position={ position }
              rotation={ rotation }
              scale={ scale }
              animation={ heroCardResolvedAnim }
            />
          )) }
        </group>
        <HeroCard
          geometry={ nodes.Card_Fail_Ending.geometry }
          position={ [-135.73, 2.05, -233.84] }
          rotation={ [0, 0.8, 0.04] }
          scale={ 6 }
          animation={ heroCardFailAnim }
        />
      </group>
    </group>
  );
};